import Action from "../../classes/Action";
import UITemplateTypes from "../../components/uisystem/templates/types";
import store, { StoreActions } from '../../state/store';
import ScenarioHealthUtils from '../../classes/utilities/ScenarioHealthUtils';
import { StepUIData } from "../../interfaces/UITemplateData";
import Step from "../../classes/scenarioElements/Step";

export default class MoveSlideAction extends Action
{
	constructor(stepToMoveFrom: Step, stepToMoveTo: Step)
	{
		const oldSlide: StepUIData = { ...store.getState().uiModule.ui[stepToMoveTo.id] };

		super(
			[stepToMoveFrom, stepToMoveTo],
			[stepToMoveFrom, stepToMoveTo, oldSlide],
			`Move Step Slide`,
			[stepToMoveFrom, stepToMoveTo]
		);
	}

	do(stepToMoveFrom: Step, stepToMoveTo: Step)
	{
		// replace the data in stepToMoveTo with stepToMoveFrom
		const currentSlide = { ...store.getState().uiModule.ui[stepToMoveFrom.id] };
		store.dispatch(StoreActions.ui.setFromCopy({ stepId: stepToMoveTo.id, content: { ...currentSlide }}));

		// set stepToMoveFrom as "Blank" template
		const blankTemplate = { ...store.getState().uiModule.slideMaster[UITemplateTypes.BLANK], slide: UITemplateTypes.BLANK, synced: true };
		store.dispatch(StoreActions.ui.setFromCopy({ stepId: stepToMoveFrom.id, content: { ...blankTemplate }}));
		ScenarioHealthUtils.CheckForQuizResults();
	}

	undo(stepToMoveFrom: Step, stepToMoveTo: Step, oldSlide: StepUIData)
	{
		// replace the data in stepToMoveFrom with stepToMoveTo
		const currentSlide = { ...store.getState().uiModule.ui[stepToMoveTo.id] };
		store.dispatch(StoreActions.ui.setFromCopy({ stepId: stepToMoveFrom.id, content: { ...currentSlide }}));

		// return oldSlide to stepToMoveTo
		store.dispatch(StoreActions.ui.setFromCopy({ stepId: stepToMoveTo.id, content: { ...oldSlide } }));
		ScenarioHealthUtils.CheckForQuizResults();
	}

	verify(stepToMoveFrom: Step, stepToMoveTo: Step)
	{
		return stepToMoveFrom && stepToMoveTo ? true : false;
	}
}
